import { render } from "./ShareDialog.vue?vue&type=template&id=3edee3fa"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"

import "./ShareDialog.vue?vue&type=style&index=0&id=3edee3fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__